import React from 'react';
import { cn } from '../../lib/cn';

const variants = {
  primary: 'bg-brand-accent text-brand-dark hover:bg-brand-accent/90 shadow-md',
  secondary: 'bg-brand-dark text-white hover:bg-brand-dark/90 shadow-md',
  outline: 'border-2 border-brand-dark/20 text-brand-dark hover:border-brand-accent',
  ghost: 'text-brand-dark hover:bg-brand-dark/5',
};

const sizes = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-6 py-3 text-base',
  lg: 'px-8 py-4 text-lg',
};

export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  href,
  ...props
}) {
  const classes = cn(
    'inline-flex items-center justify-center gap-2 rounded-xl font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent',
    variants[variant],
    sizes[size],
    className,
  );

  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button type="button" className={classes} {...props}>
      {children}
    </button>
  );
}
